import { render, staticRenderFns } from "./EmailConfigView.vue?vue&type=template&id=97460400&"
import script from "./EmailConfigView.vue?vue&type=script&lang=js&"
export * from "./EmailConfigView.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfigView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports